import images from "@assets/images";
import { useDimensionContext } from "@src/DimensionProvider";
import React from "react";
import { Image, View } from "react-native";
import Animated, {
  Extrapolation,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import ButtonSwitch from "./button-switch";
import ItemShop from "./item-shop";
import useStyles from "./styles.css";

const PalmsDropdown = () => {
  const styles = useStyles();
  const animated = useSharedValue(0);
  const { baseWidth, hudHeight } = useDimensionContext();

  const onPress = () => {
    if(animated.value === 0){
      animated.value = withTiming(1, { duration: 500});
    }else{
      animated.value = withTiming(0, { duration: 500});
    }
  };

  const containerStyle = useAnimatedStyle(() => {
    const height = interpolate(
      animated.value,
      [0, 1],
      [hudHeight * 0.21, hudHeight],
      Extrapolation.CLAMP
    );

    return {
      overflow: "hidden",
      position: "absolute",
      width: baseWidth * 0.11, 
      height: height,
      top: hudHeight * 0.48,
      left: hudHeight * 0.2,
    };
  }, [baseWidth, hudHeight]);

  const animateStyle = useAnimatedStyle(() => {
    const translateY = interpolate(
      animated.value,
      [0, 1],
      [-hudHeight * 0.356, 0],
      Extrapolation.CLAMP
    );

    return {
      transform: [{translateY}],
      width: baseWidth * 0.11, 
      height: hudHeight * 0.49,
    };
  }, [baseWidth, hudHeight]);

  const bodyStyle = useAnimatedStyle(() => {
    return {
      opacity: animated.value
    };
  }, []);


  return (
    <Animated.View pointerEvents="box-none" style={containerStyle}>
      <Animated.View style={animateStyle}>
        <Image
          resizeMode="stretch"
          source={{uri: images["palm-dropdown-bar"]}}
          style={styles.i_dropdown}
        />
        <Animated.View style={[styles.v_body, bodyStyle]}>
          <View style={styles.v_divider} />
          <ItemShop onCancel={onPress} animatedValue={animated}/>
          <View style={styles.v_divider2} />
        </Animated.View>
        <ButtonSwitch onPress={onPress} animated={animated} />
      </Animated.View>
    </Animated.View>
  );
};



export default PalmsDropdown;


